import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66c13a45"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mx-auto",
  style: {"text-align":"center","display":"flex","align-items":"center","gap":"8px","justify-content":"center"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-chevron-left",
    style: {"font-size":"1rem"}
  }),
  /*#__PURE__*/_createTextVNode("  "),
  /*#__PURE__*/_createElementVNode("label", { class: "" }, "Back to Questionnaire Overview")
], -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'BackToProjectButton',
  props: {
	selected: { type: Boolean },
	btnStyle: { type:String },
	content: { type:String },
	id: { type: String, required: true },
	dark: { type: Boolean, default: false },
	hover: { type: Boolean, default: false },
	disabled: { type: Boolean, default: false }

},
  emits: ['buttonClick', 'submit'],
  setup(__props, { emit: __emit }) {

const emit = __emit

function buttonClick() {
	emit('buttonClick')
}


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (__props.hover = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (__props.hover = false)),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (buttonClick())),
    disabled: __props.disabled,
    class: _normalizeClass(["button-default header-button ici_button w-full", [!__props.hover ? (__props.dark ? 'button-normal-dark' : 'button-normal') : 'button-over']]),
    style: _normalizeStyle(__props.btnStyle)
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["disabled", "class", "style"]))
}
}

})